import React from "react";
import styled from "styled-components";
import { mobile, mobileM, tablet } from "../responsive";
import Product from "../components/Product";
import products from "../products";
import "./styles.scss";
//
//
/*


This are the products PAGES (the individual pages for each product)




*/
const CardContainer = styled.div`
  width: 80%;
  margin: 60px 0 10px 0;
  padding: 10px;
  ${mobile({
    width: "100%",
  })}
  ${mobileM({
    width: "100%",
  })}
   ${tablet({
    width: "100%",
  })}
`;
//wrapper name & price
const ListTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
// product.name > Dimensions
const ListGroupTitle = styled.div`
  margin: 0 0 20px 0;
  padding: 0;
  color: #0f0f0fc8;

  text-transform: capitalize;
  font-weight: 600;
  font-family: "Poppins-light";
  letter-spacing: 1px;
  /*  */
  font-size: calc(7px + 1vmin);
  ${mobile({ fontSize: "calc(11px + 1vmin)" })}
  ${mobileM({ fontSize: "calc(11px + 1vmin)" })}
  ${tablet({ fontSize: "calc(11px + 1vmin)" })}
`;
// product.price
const ListGroupItem = styled.div``;
//
//
const P = styled.p`
  margin: 0px 120px 10px 0;
  font-weight: 400;
  color: #0f0f0f99;
  font-size: calc(7px + 1vmin);

  ${mobile({
    margin: "0px 0 10px 0",
    lineHeight: "calc(22px + 1vmin)",
    fontSize: "calc(9px + 1vmin)",
  })}
  ${mobileM({
    margin: "0px 70px 10px 0",
    lineHeight: "calc(20px + 1vmin)",
    fontSize: "calc(9px + 1vmin)",
  })}

${tablet({
    margin: "0px 10px 10px 0",
    lineHeight: "calc(20px + 1vmin)",
    fontSize: "calc(9px + 1vmin)",
  })}
`;

//
//
//

// --------------------------
// Dimensions
const CardDimensions = styled.div``;
const ColumnWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 10px 0;
  ${mobile({
    flexDirection: "column",
  })}
  ${mobileM({
    flexDirection: "column",
  })}
    ${tablet({
    flexDirection: "column",
  })}
`;

const ListGroupDimensions = styled.div`
  color: #0f0f0f99;

  text-transform: lowercase;
  margin: 0 20px 0 0;
  line-height: calc(18px + 1vmin);
  font-size: calc(6px + 1vmin);

  ${mobile({
    margin: "0",
    lineHeight: "calc(22px + 1vmin)",
    fontSize: "calc(9px + 1vmin)",
  })}
  ${mobileM({
    margin: "0",
    lineHeight: "calc(24px + 1vmin)",
    fontSize: "calc(10px + 1vmin)",
  })}
`;
//
//
//----------------------------
// status
const CardStatus = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0 10px 0;
`;
const StatusItem = styled.div`
  font-size: calc(6px + 1vmin);
  ${mobile({ fontSize: "calc(11px + 1vmin)" })}
  ${mobileM({ fontSize: "calc(11px + 1vmin)" })}
  p {
    padding: 0;
    text-transform: capitalize;
    font-weight: 600;
    font-family: "Poppins-light";
    letter-spacing: 1px;
    font-weight: 600;
    color: #0f0f0f99;
  }
`;
//----------------------------
//
// --------
// BUTTON
// --------
//
const TopButton = styled.button`
  width: 100%;
  padding: 1.5em 0;
  margin: 1em 0;

  box-sizing: border-box;
  text-decoration: none;
  text-align: left;
  text-transform: capitalize;
  font-size: calc(5px + 1vmin);

  font-weight: 600;
  font-family: "Poppins-light";
  letter-spacing: 1px;

  //
  transition: all 0.2s;
  color: #27272781;
  background-color: transparent;
  border-left: 0;
  border-right: 0;

  border-top: 0.8px dotted #2727274e;
  border-bottom: 0.8px dotted #2727274e;

  //
  //
  .btnAnimation {
    position: relative;
    /* z-index: 3; */
    padding: 3px 1px 3px 0;
    //  underline animation

    &::after {
      content: "";
      position: absolute;
      width: 100%;
      transform: scaleX(0);
      height: 100%;
      bottom: 0;
      left: 0;
      background-color: #fff78e2b;
      transform-origin: bottom right;
      transition: transform 0.35s ease-out;
    }

    &:hover {
      &::after {
        transform: scaleX(1);

        transform-origin: bottom left;
      }
    }
  }
`;

//
//
const CardDelivery = styled.div`
  width: 80%;
  margin: 40px 0 10px 0;
  padding: 10px;
  ${mobile({ width: "100%", padding: "0" })}
  ${mobileM({ width: "100%" })}
  ${tablet({ width: "100%" })};
`;
//wrapper name & price
const ListTitleDelivery = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

// product.price
const ListGroupItemDelivery = styled.div``;
//

//
// ---------------------
//    Second section
// ---------------------
const SectionGallery = styled.div`
  width: 100vw;
`;

//
const GalleryWrapper = styled.div`
  width: 100%;
  padding: 100px 0 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  //
  ${mobile({ width: "100%", padding: "20px 0 0px 0" })}
  ${mobileM({ width: "100%" })}
  ${tablet({ width: "100%" })};
`;

const H1 = styled.h1`
  padding: 70px 0 0 0;
  font-weight: 600;
  font-size: 1.6em;
  font-family: "Poppins-Light";
  text-transform: Capitalize;
  letter-spacing: 3px;
  text-align: center;
  color: #272727f8;
  ${mobile({ fontSize: "calc(13px + 1.5vmin)" })}
  ${mobileM({ fontSize: "calc(16px + 1.5vmin)" })}
`;
const H2 = styled.h1`
  padding: 0 0 40px 0;
  line-height: 20px;
  font-weight: 600;
  font-size: 0.9em;
  font-family: "Poppins-Light";
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;

  color: #272727e6;
  ${mobile({
    padding: "0 0 40px 0",
    lineHeight: "25px",
    fontSize: "calc(10px + 1.5vmin)",
    color: "#8741125c",
    fontWeight: "500",
  })}
  ${mobileM({ fontSize: "calc(10px + 1.5vmin)" })}
`;

//

//
//
//
const GalleryProductContainer = styled.div`
  width: 100%;

  padding: 0.5em 1em;
  grid-template-columns: repeat(3, 1fr);
  display: grid;
  grid-gap: 1.8em;

  /*  */
  ${mobile({
    display: "grid",
    gridGap: "0.1em",
    gridTemplateColumns: "repeat(1, 1fr)",
    padding: "none",
  })}
  ${mobileM({
    textAlign: "center",
    padding: "40px 20px",
    display: "grid",
    gridGap: "1em",
    gridTemplateColumns: "repeat(1, 1fr)",
  })}
    ${tablet({
    textAlign: "center",
    padding: "40px",
    display: "grid",
    gridGap: "1em",
    gridTemplateColumns: "repeat(2, 1fr)",
  })}
`;

const Card = styled.div`
  width: 100%;
  overflow: hidden;

  height: auto;
  padding: 1% 0 0.1% 0;
`;

//

const ProductScreen = ({ match }) => {
  //
  const product = products.find((p) => p._id === match.params.id);

  //
  //

  //

  return (
    <>
      <section>
        <div className="text-product">
          <CardContainer>
            <ListTitle>
              <ListGroupTitle>{product.name}</ListGroupTitle>
              <ListGroupItem>${product.price}</ListGroupItem>
            </ListTitle>
            <ListGroupItem>
              <P>{product.description}</P>
            </ListGroupItem>
          </CardContainer>

          <CardContainer>
            <CardDimensions>
              <ListGroupTitle>Dimensions</ListGroupTitle>
              <ColumnWrap>
                {" "}
                <ListGroupDimensions>
                  Height(cm) {product.height}
                </ListGroupDimensions>
                <ListGroupDimensions>
                  Width(cm) {product.width}
                </ListGroupDimensions>
                <ListGroupDimensions>
                  Depth(cm) {product.depth}
                </ListGroupDimensions>
                <ListGroupDimensions>
                  Weight(Kg) {product.weight}
                </ListGroupDimensions>
              </ColumnWrap>
            </CardDimensions>
          </CardContainer>

          <CardContainer>
            <CardStatus>
              <ListGroupTitle>Status</ListGroupTitle>
              <StatusItem>
                <p>{product.countInStock > 0 ? "In Stock" : "Out of Stock"}</p>
              </StatusItem>
            </CardStatus>

            <TopButton type="button" disabled={product.countInStock === 0}>
              <h3 className="btnAnimation">ADD TO CART</h3>
            </TopButton>
          </CardContainer>

          {/*  
          
          new
          
          
          */}

          <CardDelivery>
            <ListTitleDelivery>
              <ListGroupTitle>Delivery</ListGroupTitle>
              <ListGroupTitle>${product.delivery}</ListGroupTitle>
            </ListTitleDelivery>
            <ListGroupItemDelivery>
              <P>
                {" "}
                If you are unsatisfied with your purchase, notify us within 14
                days of receipt, and we will take it back for a full refund or
                help you find a suitable replacement.<br></br> <br></br>After 30
                days, you can do the same, but you will be charged a 30%
                re-stocking fee on the item returned. We do not accept returns
                if you’ve had the item for more than 60 days, unless it's
                defective.
              </P>
            </ListGroupItemDelivery>
          </CardDelivery>

          {/*  */}
        </div>
        <div className="full-img">
          <div className="img-box">
            {" "}
            <img className="img1ProductScreen" src={product.image} alt="" />
            <img className="img2ProductScreen" src={product.image} alt="" />
          </div>
        </div>
      </section>

      {/* 
      
      Second section
      
      */}
      <section>
        <SectionGallery>
          {" "}
          <GalleryWrapper>
            <H1>The Collection</H1>
            <H2>SHOP NOW</H2>
            <GalleryProductContainer>
              {products.slice(0, 3).map((product) => (
                <div key={product._id}>
                  <Card>
                    <Product product={product} />
                  </Card>
                </div>
              ))}
            </GalleryProductContainer>
          </GalleryWrapper>{" "}
        </SectionGallery>
      </section>
    </>
  );
};

export default ProductScreen;

/*


const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 0 0 100px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  background-color: rgb(243, 243, 243); //

  ${mobile({ flexDirection: "column", padding: "0 0 100px  0" })}
  ${mobileM({ flexDirection: "column", padding: "0 0 100px  0" })}
  ${tablet({ flexDirection: "column", padding: "0 0 100px  0" })}
`;

const Left = styled.div`
  flex: 1;
  height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  overflow: hidden;
`;

const ImgWrapper = styled.div`
  width: 100%;
  height: 100%;
  .ImgContainer {
    width: 100%;
    height: 100%;
  }
`;

//----------------------
//        right
//----------------------
//
const Right = styled.div`
  flex: 1;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
//
const CardContainer = styled.div`
  width: 80%;
  margin: 0 0 10px 0;
  padding: 10px;
 
  `;
  //wrapper name & price
  const ListTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  
    
  `;
  // product.name > Dimensions
  const ListGroupTitle = styled.div`
    margin: 0 0 20px 0;
    padding: 0;
    color: #0f0f0fc8;
    font-size: calc(10px + 1vmin);
    text-transform: capitalize;
    font-weight: 600;
    font-family: "Poppins-light";
    letter-spacing: 1px;
  `;
  // product.price
  const ListGroupItem = styled.div``;
  //
  //
  const P = styled.p`
    margin: 0px 120px 10px 0;
    font-weight: 400;
    color: #0f0f0f99;
    font-size: calc(7px + 1vmin);
  `;
  
  //
  //
  //
  
  // --------------------------
  // Dimensions
  const CardDimensions = styled.div`
    .column-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 10px 0 10px 0;
    }
  `;
  
  const ListGroupDimensions = styled.div`
    color: #0f0f0f99;
    line-height: calc(18px + 1vmin);
    font-size: calc(6px + 1vmin);
    text-transform: lowercase;
  `;
  //
  //
  //----------------------------
  // status
  const CardStatus = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 10px 0 10px 0;
  `;
  const StatusItem = styled.div``;
  //----------------------------
  //
  // --------
  // BUTTON
  // --------
  //
  const TopButton = styled.button`
    width: 100%;
    padding: 1.5em 0;
    margin: 1em 0;
  
    box-sizing: border-box;
    text-decoration: none;
    text-align: left;
    text-transform: capitalize;
    font-size: calc(5px + 1vmin);
  
    font-weight: 600;
    font-family: "Poppins-light";
    letter-spacing: 1px;
  
    //
    transition: all 0.2s;
    color: #27272781;
    background-color: transparent;
    border-left: 0;
    border-right: 0;
 
    border-top: 0.8px dotted #2727274e;
    border-bottom: 0.8px dotted #2727274e;
  
    //
    //
    .btnAnimation {
      position: relative;
      z-index: 3;
      padding: 3px 1px 3px 0;
      //  underline animation
  
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: 100%;
        bottom: 0;
        left: 0;
        background-color: #fff78e2b;
        transform-origin: bottom right;
        transition: transform 0.35s ease-out;
      }
  
      &:hover {
        &::after {
          transform: scaleX(1);
  
          transform-origin: bottom left;
        }
      }
    }
  `;
 


    return (
    <>
      <Wrapper>
        <Left>
          <ImgWrapper>
            <div
              className="ImgContainer"
              style={{
                backgroundRepeat: "no-repeat",
                backgroundImage: `url(${product.image})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
            ></div>
          </ImgWrapper>
        </Left>

        <Right>
          <CardContainer>
            <ListTitle>
              <ListGroupTitle>{product.name}</ListGroupTitle>
              <ListGroupItem>${product.price}</ListGroupItem>
            </ListTitle>
            <ListGroupItem>
              <P>{product.description}</P>
            </ListGroupItem>
          </CardContainer>
     
          <CardContainer>
            <CardDimensions>
              <ListGroupTitle>Dimensions</ListGroupTitle>
              <div className="column-wrap">
                {" "}
                <ListGroupDimensions>
                  Height(cm) {product.height}
                </ListGroupDimensions>
                <ListGroupDimensions>
                  Width(cm) {product.width}
                </ListGroupDimensions>
                <ListGroupDimensions>
                  Depth(cm) {product.depth}
                </ListGroupDimensions>
                <ListGroupDimensions>
                  Weight(Kg) {product.weight}
                </ListGroupDimensions>
              </div>
            </CardDimensions>
          </CardContainer>
 
          <CardContainer>
            <CardStatus>
              <ListGroupTitle>Status</ListGroupTitle>
              <StatusItem>
                {product.countInStock > 0 ? "In Stock" : "Out of Stock"}
              </StatusItem>
            </CardStatus>

       
            <TopButton type="button" disabled={product.countInStock === 0}>
              <h3 className="btnAnimation">ADD TO CART</h3>
            </TopButton>
          </CardContainer>
        </Right>
      </Wrapper>
    </>
  );



*/
